import { useState, useEffect } from 'react'
import { cn } from '@/lib/utils'

interface CaptureFlashProps {
  isCapturing: boolean
  showSuccess?: boolean
}

export function CaptureFlash({ isCapturing, showSuccess = false }: CaptureFlashProps) {
  const [showFlash, setShowFlash] = useState(false)
  const [showCheck, setShowCheck] = useState(false)

  useEffect(() => {
    if (isCapturing) {
      setShowFlash(true)
      const timer = setTimeout(() => {
        setShowFlash(false)
        if (showSuccess) {
          setShowCheck(true)
          setTimeout(() => setShowCheck(false), 600)
        }
      }, 150)
      return () => clearTimeout(timer)
    }
  }, [isCapturing, showSuccess])

  if (!showFlash && !showCheck) return null

  return (
    <>
      {/* White flash overlay */}
      {showFlash && (
        <div
          className={cn(
            'absolute inset-0 bg-white pointer-events-none z-10',
            'animate-capture-flash'
          )}
        />
      )}

      {/* Success checkmark */}
      {showCheck && (
        <div
          className={cn(
            'absolute inset-0 flex items-center justify-center pointer-events-none z-10'
          )}
        >
          <div
            className={cn(
              'bg-green-500 text-white rounded-full p-4',
              'animate-success-pop'
            )}
          >
            <svg
              className="h-12 w-12"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={3}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 13l4 4L19 7"
                className="animate-[draw-check_300ms_ease-out_100ms_forwards]"
                style={{
                  strokeDasharray: 24,
                  strokeDashoffset: 24,
                }}
              />
            </svg>
          </div>
        </div>
      )}
    </>
  )
}
